import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-get-packers-movers-config',
  templateUrl: './get-packers-movers-config.component.html',
  styleUrls: ['./get-packers-movers-config.component.sass']
})
export class GetPackersMoversConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
